export default __webpack_public_path__ + "static/media/dogHungry.12453f85.jpg";